import { Card, CardContent, CardHeader, CardTitle } from '@/client/components/ui/card';
import { Badge } from '@/client/components/ui/badge';
import { Contact, Mail } from 'lucide-react';
import type { ClientUserResponse } from '@shared/types';

interface ContactsCardProps {
  /** Users designated as primary business contacts (see CLIENT_PRIMARY_CONTACTS) */
  contacts: ClientUserResponse[];
}

/**
 * Primary business contacts for the client. Not technicians — those are in TechsCard.
 * Sourced from the hand-maintained CLIENT_PRIMARY_CONTACTS map until #227 adds a contacts table.
 */
export function ContactsCard({ contacts }: ContactsCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-medium flex items-center gap-2">
            <Contact className="h-4 w-4" />
            Primary Contacts
          </CardTitle>
          {contacts.length > 0 && <Badge variant="secondary">{contacts.length}</Badge>}
        </div>
      </CardHeader>
      <CardContent>
        {contacts.length === 0 ? (
          <p className="text-sm text-muted-foreground italic">
            No primary contacts designated yet.
          </p>
        ) : (
          <div className="space-y-2">
            {contacts.map((user) => {
              const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
              return (
                <div key={user.userId} className="flex items-center gap-2 text-sm">
                  <Mail className="h-3 w-3 text-muted-foreground" />
                  <span className="font-medium">{name || user.email}</span>
                  {name && <span className="text-xs text-muted-foreground">({user.email})</span>}
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
